import {I_ACCESS_TOKEN_PARAMS,I_COMMON_DELETE_PARAMS,_customFetch, getFetchDELETEOptions, getFetchGETOptions} from './_base';
import LoggerService,{formatTrace} from '../../LoggerService';
import APP_CONFIG from 'config';

// ---------------------------------
// --- LOGS
// ---------------------------------

const ENDPOINT_FILTERS = '/users';

const logger = LoggerService.getInstance();

interface I_GET_PARAMS extends I_ACCESS_TOKEN_PARAMS {
  user_id: number;
  type?: string;
}
/**
 * Requete le endpoint
 * Récupère la liste des filtres
 * @param param0
 */
const getFilters = async ({
  accessToken,
  user_id,
  type,
}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - filters - get...'));
  const options = getFetchGETOptions({accessToken});
  const paramType = type ? `type=${type}` : undefined;
  const paramsAll = [paramType].join('&');
  const URL = `${ENDPOINT_FILTERS}/${user_id}/filters${APP_CONFIG.ENDPOINT_SUFFIX}?${paramsAll}`;
  return _customFetch(URL,options);
};


interface I_POST_PARAMS {
  accessToken: string;
  user_id: number;
  name: string;
  type: string;
  data: object;
}
/**
 * Requete le endpoint  POST
 * Ajoute un organisme audité
 * @param param0
 * @returns
 */
export const postFilter = async ({
  accessToken,
  user_id,
  name,
  type,
  data,
}:I_POST_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - filters - post...'));
  const params = {
    method: 'POST',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      name: encodeURIComponent(name.trim()),
      type: encodeURIComponent(type.trim()),
      data,
  })
  };
  const URL = `${ENDPOINT_FILTERS}/${user_id}/filters${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,params);
};


interface I_DELETE_PARAMS extends I_COMMON_DELETE_PARAMS {
  user_id: number;
}
/**
 * Requete le endpoint  DELETE
 * Supprime un filtre
 * @param param0
 * @returns
 */
const deleteFilter = async ({
  accessToken,
  id,
  user_id,
}:I_DELETE_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - filters - remove...'));
  const options = getFetchDELETEOptions({accessToken});
  const URL = `${ENDPOINT_FILTERS}/${user_id}/filters/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};


interface I_PUT_PARAMS {
  accessToken: string;
  id: number;
  user_id: number;
  name: string;
}
/**
 * Requete le endpoint PUT
 * Met à jour le nom d'un filtre
 * @param param0
 * @returns
 */
const putFilter = async ({
  accessToken,
  id,
  user_id,
  name,
}:I_PUT_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - filters - put...'));
  const params = {
    method: 'PUT',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      name: encodeURIComponent(name.trim()),
    })
  };
  const URL = `${ENDPOINT_FILTERS}/${user_id}/filters/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,params);
};

const logsEndpoints = {
  getFilters,
  postFilter,
  deleteFilter,
  putFilter,
};

export default logsEndpoints;
